import {
  MeasurementRequest,
  MeasurementRequestMinimal,
  RawMeasurementRequest,
  RawMeasurementRequestMinimal,
  WaferStatus,
} from "@/types/measurementRequest";
import { mapRawToProject } from "./project";
import { mapRawToMeasurementRequestComment } from "./measurementRequestComment";

export const mapRawToMeasurementRequestMinimal = (
  raw: RawMeasurementRequestMinimal,
): MeasurementRequestMinimal => {
  return {
    createdAt: new Date(raw.created_at),
    id: raw.id,
    imecLotId: raw.imec_lot_id,
    mask: {
      id: raw.mask.id,
      pcmVersion: raw.mask.pcm_version,
      name: raw.mask.name,
    },
    createdBy: raw.created_by,
    name: raw.name,
    sfabLotId: raw.sfab_lot_id,
    status: raw.status,
    project: mapRawToProject(raw.project),
    testLabel: {
      id: raw.test_label.id,
      name: raw.test_label.name,
    },
  };
};

export const mapRawToMeasurementRequest = (raw: RawMeasurementRequest): MeasurementRequest => {
  return {
    comments: raw.comments.map(mapRawToMeasurementRequestComment),
    createdAt: new Date(raw.created_at),
    id: raw.id,
    imecLotId: raw.imec_lot_id,
    mask: {
      id: raw.mask.id,
      pcmVersion: raw.mask.pcm_version,
      name: raw.mask.name,
    },
    testLabel: {
      id: raw.test_label.id,
      name: raw.test_label.name,
      measurementCapability: {
        id: raw.test_label.measurement_capability.id,
        name: raw.test_label.measurement_capability.name,
      },
      isArchived: raw.test_label.is_archived,
    },
    physicalLocation: raw.physical_location,
    projectId: raw.project_id,
    createdBy: raw.created_by,
    name: raw.name,
    sfabLotId: raw.sfab_lot_id,
    targetDate: raw.target_date,
    status: raw.status,
    measurementKey: raw.measurement_key,
    priority: raw.priority,
    waferRequests: raw.wafer_requests.map((cur) => ({
      _id: cur.id,
      id: cur.wafer_id,
      name: cur.wafer.name,
      chipPos: cur.chip_pos_id,
      chipPosName: cur.chip_pos.name,
      dieCount: cur.total_dies, // Use backend calculated value
      estimatedTime: cur.estimated_time / 60,
      stackShort: cur.stack_short,
      status: cur.status as WaferStatus,
      measurementSystemId: cur.measurement_system_id,
      measurementSystem: cur.measurement_system,
      priority: cur.priority,
      estFinishTime: cur.est_finish_time,
      estStartTime: cur.est_start_time,
      startedAt: cur.started_at,
      completedAt: cur.completed_at,
    })),
    project: mapRawToProject(raw.project),
  };
};
